"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Pagination = _interopRequireDefault(require("@mui/material/Pagination"));

var _styles = require("@mui/material/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledPagination = (0, _styles.styled)(_Pagination.default)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiPaginationItem-text': {
      color: theme.palette.font.secondary
    }
  };
});

var BrandPagination = function BrandPagination(props) {
  return /*#__PURE__*/_react.default.createElement(StyledPagination, _extends({}, props, {
    color: "primary",
    siblingCount: 0,
    boundaryCount: 1
  }));
};

var _default = BrandPagination;
exports.default = _default;